import React, { Component } from 'react';
import { Button, Dimmer, Icon, Loader, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { ITrain } from '@relab/alstom-ptw-shared';

import { appState, appStateServerRequests } from '../../redux/selectors';
import { ActionType, RootState, ServerRequestStatus } from '../../redux/types';
import { trainDeleteAction } from '../../redux/actions';
import { TranslationComponent } from '../TranslationComponent';

interface TrainDeleteModalProps {
  projectId: string;
  train: ITrain;
  trainDeleteAction: any;
  serverRequest?: ServerRequestStatus;
}

class PTrainDeleteModal extends Component<TrainDeleteModalProps> {
  state = { modalOpen: false };

  handleOpen = () => this.setState({ modalOpen: true });

  handleClose = () => this.setState({ modalOpen: false });

  handleDelete = () => {
    this.props.trainDeleteAction(this.props.projectId, this.props.train._id);
  };

  render() {
    const { serverRequest } = this.props;
    let serverRequestFeedback = null;

    if (serverRequest) {
      if (serverRequest.pending) {
        serverRequestFeedback = (
          <Dimmer active inverted>
            <Loader inverted>
              <TranslationComponent stringKey={'Loading'} />
            </Loader>
          </Dimmer>
        );
      } else if (serverRequest.error) {
        serverRequestFeedback = serverRequest.error;
      }
    }

    return (
      <Modal
        trigger={
          <Button icon onClick={this.handleOpen}>
            <Icon name="remove circle" />
          </Button>
        }
        open={this.state.modalOpen}
        onClose={this.handleClose}
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Delete Train'} />
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <p>
              <TranslationComponent stringKey={'Are you sure?'} />
            </p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {serverRequestFeedback}
          <Button onClick={this.handleClose}>
            <TranslationComponent stringKey={'Cancel'} />
          </Button>
          <Button color="red" onClick={this.handleDelete}>
            <TranslationComponent stringKey={'Confirm'} />
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  projectId: appState(state).project._id,
  serverRequest: appStateServerRequests(state, ActionType.TRAIN_DELETE),
});

export const TrainDeleteModal = connect(mapStateToProps, { trainDeleteAction })(PTrainDeleteModal);
